import React, {PropsWithChildren} from 'react'

import {Link, useNavigate} from 'react-router-dom'

import logo from '../assets/logo-small.png'

export default function KurzyLayout({children}: PropsWithChildren<unknown>) {
    const navigate = useNavigate()

    return (
        <>
            <div className="container-fluid kurzy-layout">
                <div className="row">
                    <div className="sidebar  col-lg-2 p-0 bg-yellow-light">

                        <div
                            className="d-flex flex-lg-nowrap justify-content-between align-items-center justify-content-lg-center">
                            <a className="navbar-brand no-bg "
                               href={'/'}>
                                <img src={logo} style={{width: '150px'}}/>
                            </a>
                            <ul className="navbar-nav flex-row d-lg-none">
                                <li className="nav-item text-nowrap">
                                    <button className="nav-link px-3 text-black" type="button"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#sidebarMenu" aria-controls="sidebarMenu"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation">
                                        Menu
                                        {/*<svg className="bi">*/}
                                        {/*    <use xlinkHref="#list"/>*/}
                                        {/*</svg>*/}
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className="offcanvas-lg offcanvas-end " tabIndex={-1} id="sidebarMenu"
                             aria-labelledby="sidebarMenuLabel">
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="sidebarMenuLabel">Amani</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas"
                                        data-bs-target="#sidebarMenu" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto">


                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <Link to={'/kurzy-pri-kavicke'}
                                              className="nav-link d-flex align-items-center gap-2 text-uppercase">
                                            Pri kávičke
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/kurzy-materialy'}
                                              className="nav-link d-flex align-items-center gap-2 text-uppercase">
                                            Materiály
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/kurzy-webinare'}
                                              className="nav-link d-flex align-items-center gap-2 text-uppercase">
                                            Webináre
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/kurzy-kurzy'}
                                              className="nav-link d-flex align-items-center gap-2 text-uppercase">
                                            Kurzy
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/kurzy-lektori'}
                                              className="nav-link d-flex align-items-center gap-2 text-uppercase">
                                            Lektori
                                        </Link>
                                    </li>

                                </ul>

                            </div>
                        </div>
                    </div>

                    <main className="main-content ms-sm-auto col-lg-10 col-md-12 ps-4 pe-4">
                        {/*<TimeTrackingWidget />*/}

                        {children}
                    </main>
                </div>
            </div>
        </>

    )
}